module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-2_LT-281073bd19823be07f187aa81b76a84e.svg";